import { Link, LoaderFunctionArgs, useLoaderData } from 'react-router';
import { urlControlPanel, urlCourt, urlCourtList } from '@/urls';
import { CourtCard } from '@/components/courts/court-card';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@repo/ui/components/dialog';
import { EmptyState } from '@repo/ui/components/empty-state';
import { PlusIcon } from 'lucide-react';
import { Button } from '@repo/ui/components/button';
import { courtApi } from '@repo/api-client';
import { useState } from 'react';
import { CreateCourtForm } from '@/components/courts/create-court-form';

function CourtList() {
  const { clubId, courts } = useLoaderData<typeof route.loader>();
  const [open, setOpen] = useState(false);

  const createCourtDialog = (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>
        <Button>
          <PlusIcon className="w-4 h-4" />
          Crear Cancha
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle>Crear Cancha</DialogTitle>
        <DialogDescription>Completa los campos para crear una nueva cancha.</DialogDescription>
        <CreateCourtForm clubId={clubId} onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );

  if (courts.length === 0) {
    return (
      <EmptyState
        title="No hay canchas disponibles"
        description="Crea una cancha para empezar"
        actions={createCourtDialog}
      />
    );
  }

  return (
    <>
      {createCourtDialog}
      <div className="my-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {courts.map((court) => (
          <Link key={court.id} to={urlCourt(clubId, court.id)} viewTransition>
            <CourtCard court={court} clubId={clubId} />
          </Link>
        ))}
      </div>
    </>
  );
}

export const route = {
  path: urlCourtList(':id'),
  element: <CourtList />,
  loader: async ({ params }: LoaderFunctionArgs) => {
    const clubId = params.id as string;
    try {
      const courts = await courtApi.getAll(clubId);
      return { clubId, courts: courts.results };
    } catch {
      return { clubId, courts: [] };
    }
  },
  handle: {
    title: 'Canchas',
    backLink: (params: { id: string }) => urlControlPanel(params.id),
  },
};
